import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NopeZone from 'InpageEditorUI/components/NopeZone';
import { getNodePositionsByTreeId, getNodePositionsByStaticModuleId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getNopeZoneSelector } from 'ContentEditorUI/redux/selectors/inpageSelectors';
// @ts-expect-error not yet migrated
import { generateTilesOutsideOf } from 'layout-dnd-utils/geometry/tiling';
// @ts-expect-error not yet migrated
import { getElementBounds } from 'layout-dnd-utils/dom/bounds';
import { jsx as _jsx } from "react/jsx-runtime";
const generateNopeZoneTiles = (nodePositionsByTreeId, nodePositionsByStaticModuleId, nopeZoneSelector) => {
  const documentBounds = getElementBounds(document.documentElement, {
    applyScrollOffset: true
  });
  if (!nodePositionsByStaticModuleId || !nodePositionsByTreeId) {
    return [];
  }
  const positionForAllDndAreas = Object.keys(nodePositionsByTreeId).map(layoutSectionId => {
    return nodePositionsByTreeId[layoutSectionId][layoutSectionId];
  });
  const positionForAllStaticModules = Object.values(nodePositionsByStaticModuleId);
  if (positionForAllDndAreas.length > 0 || positionForAllStaticModules.length > 0 || nopeZoneSelector) {
    let tiles;
    const boundsToCheck = [...positionForAllDndAreas, ...positionForAllStaticModules];
    if (nopeZoneSelector) {
      const nopeZoneElement = document.querySelector(nopeZoneSelector);
      if (nopeZoneElement) {
        boundsToCheck.push(getElementBounds(nopeZoneElement));
      }
    }
    try {
      tiles = generateTilesOutsideOf(documentBounds, boundsToCheck);
    } catch (err) {
      console.error('Error generating nope zone tiles: ', err);
    }
    if (tiles) {
      return tiles;
    }
  }
  return [];
};
function StaticNopeZoneContainer() {
  const [nopeZoneTiles, setNopeZoneTiles] = useState([]);
  const nodePositionsByTreeId = useSelector(getNodePositionsByTreeId);
  const nodePositionsByStaticModuleId = useSelector(getNodePositionsByStaticModuleId);
  const nopeZoneSelector = useSelector(getNopeZoneSelector);
  useEffect(() => {
    const updatedTiles = generateNopeZoneTiles(nodePositionsByTreeId, nodePositionsByStaticModuleId, nopeZoneSelector);
    setNopeZoneTiles(updatedTiles);
  }, [nodePositionsByTreeId, nodePositionsByStaticModuleId, nopeZoneSelector]);
  return (
    /*#__PURE__*/
    // Explicitly not using styled components to avoid namespacing, which
    // prevents this edge case:
    // https://git.hubteam.com/HubSpot/ContentEditorUI/pull/13640
    // @bend-expect trellis-tokenized
    _jsx("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0
      },
      children: nopeZoneTiles.map((tile, i) => /*#__PURE__*/_jsx(NopeZone, {
        top: tile.top,
        bottom: tile.bottom,
        right: tile.right,
        left: tile.left,
        backgroundColor: "#FFFFFF",
        opacity: 0.9,
        cursor: "not-allowed"
      }, i))
    })
  );
}
export default StaticNopeZoneContainer;